var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.266 6.4838C15.2579 7.25128 15.2579 8.74874 14.266 9.51622C11.2685 11.8356 7.9213 13.6638 4.34976 14.9322L3.69728 15.164C2.44901 15.6073 1.1305 14.7628 0.961511 13.4742C0.489351 9.874 0.489352 6.12601 0.961511 2.5258C1.1305 1.23725 2.44901 0.392692 3.69729 0.836032L4.34976 1.06777C7.9213 2.33625 11.2685 4.1644 14.266 6.4838ZM13.3481 8.32988C13.5639 8.16291 13.5639 7.83711 13.3481 7.67013C10.4763 5.44802 7.26948 3.69654 3.84774 2.48126L3.19526 2.24953C2.87031 2.13412 2.49688 2.35407 2.44877 2.72085C1.9936 6.19158 1.9936 9.80843 2.44877 13.2792C2.49688 13.6459 2.87031 13.8659 3.19526 13.7505L3.84774 13.5188C7.26947 12.3035 10.4763 10.552 13.3481 8.32988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.5e8d6665d8ce7c1fac67de217a531150.svg";
export { ForwardRef as ReactComponent };